import React from "react";
import {useHeader} from "../../_metronic/layout";
import {useSubheader} from "../../_metronic/layout";
import {useIntl} from "react-intl";
import {default as CompleteDetails} from "../modules/CompleteDetails/CompleteDetailsPage";

export function CompleteDetailsPage() {
  const header = useHeader();
  header.setTitle(useIntl().formatMessage({
    id: "complete-details-page-title",
    defaultMessage: "Automated pages"
  }));
  const subheader = useSubheader();
  subheader.setCustomClassName("subheader-custom-height");
  subheader.setDisplaySubheader(false);

  return <CompleteDetails/>;
}
